import {Suspense} from "react";
import {Route, Redirect} from "react-router-dom";
import {pathsBeforeLoginForPrivateRoutes, pathsValidForGestUsers, TOAST_ERROR, TOAST_WARN} from "../assets/constants/Constants";
import {LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK, USER_INFO} from "../assets/constants/BrowserStorageKeys";
import {isGuestUserAuthenticated} from "../lib/AuthUtils";
import {getSecureItemFromSpecificStorage} from "../lib/BrowserStorageAccessMiddleware";
import { getPathForNextPage } from "../lib/Utils";
import { ACCESS_LOCKER_BANK, LOGIN, QR_CODE_LANDING } from "../assets/constants/PageList";


export const ProtectedRoute = ({component: Component, ...rest}) => {
    const domainAndLockerBankId = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK);
    const areBothDomainAndLockerBankIdValid = ((domainAndLockerBankId?.domain) && (domainAndLockerBankId?.lockerBankId)) ? true : false;
    const userInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, USER_INFO);
    const isUserAuthenticated = isGuestUserAuthenticated(userInfo);
    const gestUser = getSecureItemFromSpecificStorage(LOCAL_STORAGE, 'guess_token');
    console.log("gestUser is ", gestUser);
    const isPathForProtectedRoute = pathsBeforeLoginForPrivateRoutes.includes(window.location.pathname);
    const isPathsForGestUsers = pathsValidForGestUsers.includes(window.location.pathname);
    const loginPath = getPathForNextPage(ACCESS_LOCKER_BANK, LOGIN);
    const isLoginPagePath = loginPath ? window.location.pathname === loginPath : false;
    console.log("isPathsForGestUsers is valid :", isPathsForGestUsers , " path name is :", window.location.pathname)


    let message;
    let messageType;

    if (!areBothDomainAndLockerBankIdValid) {
        message = `We couldn't understand which locker bank you were trying to access. Please scan the QR code on the locker bank and try again.`;
        messageType = TOAST_ERROR;
    }
    if (areBothDomainAndLockerBankIdValid && (!isUserAuthenticated)) {
        message = `Please login to book a new locker or to access your locker.`;
        messageType = TOAST_WARN;
    }
    return (
        <Route {...rest} render={(props) => {
            if (isUserAuthenticated && isLoginPagePath) {
                return <Suspense fallback={<></>} ><Component {...props} /></Suspense>
            }
            if ((areBothDomainAndLockerBankIdValid && (isUserAuthenticated || isPathForProtectedRoute)) || (gestUser && isPathsForGestUsers)) {
                return <Suspense fallback={<></>} ><Component {...props} /></Suspense>
            }
            else {
                return (
                    <Redirect
                        to={{
                            pathname: getPathForNextPage(QR_CODE_LANDING, ACCESS_LOCKER_BANK) || "/",
                            state: {
                                message: message,
                                messageType: messageType
                            }
                        }}
                    />
                );
            }
        }}
        />
    );
};
